<div class="pointer-events-none" [ngStyle]="contentStyle">
  <form [formGroup]="searchForm" class="w-100">
    <finxone-input
      formControlName="businessNumber"
      [parentControl]="$any(searchForm.get('businessNumber'))"
      [label]="businessNumberLabel"
      type="text"
      [value]="searchForm.get('businessNumber')?.value"
      [showErrors]="true"
    ></finxone-input>

    @if (showSeparator) {
      <div [innerHTML]="separatorLabel"></div>
    }
    <div class="d-flex flex-col finxForm" [style.gap]="parentFormWidgetRowGap">
      @if (showCompanyName) {
        <finxone-input
          formControlName="companyName"
          [parentControl]="$any(searchForm.get('companyName'))"
          [label]="companyNameLabel"
          type="text"
          [value]="searchForm.get('companyName')?.value"
          [showErrors]="true"
        ></finxone-input>
      }

      @if (showLocation) {
        <finxone-input
          formControlName="location"
          [parentControl]="$any(searchForm.get('location'))"
          [label]="locationLabel"
          type="text"
          [value]="searchForm.get('location')?.value"
          [showErrors]="true"
        ></finxone-input>
      }
    </div>

    <div class="mt-4">
      <button
        type="button"
        [class]="isAllowedGlobalStyling ? globalStylingClass + ' d-flex' : 'search-button'"
        [ngStyle]="isAllowedGlobalStyling ? {} : searchButtonStyle"
        [disabled]="isSearching"
        (click)="onSearch()"
      >
        <span>{{ isSearching ? 'Searching...' : searchButtonLabel }}</span>
      </button>
    </div>
  </form>
</div>
